import { actions } from '../../actions/common/search';

export default function search( state, action ) {
    if( !state ) {
        return {
            selectedCountry: 77,
        };
    }

    const newState = { ...state };

    switch( action.type ) {
        case actions.TOGGLE_COUNTRY_SELECTOR: return toggleCountry( newState, action.countryId );
        case actions.SET_LOCATIONS_DATA: return setLocations( newState, action.locations );
        case actions.SET_EXPERTISE: return setExpertise( newState, action.expertise );
        case actions.SET_INDUSTRIES: return setIndustries( newState, action.industries );
        case actions.SET_REMUNERATION_TYPES: return setRemunerationTypes( newState, action.remuneration_types );
        case actions.SET_SECTORS: return setSectors( newState, action.sectors );
        default: return state;
    }
}

function toggleCountry( newState, countryId ) {
    newState.selectedCountry = countryId;

    return newState;
}

function setLocations( newState, locations ) {
    newState.locations = locations;
    return newState;
}

function setExpertise( newState, expertise ) {
    newState.expertise = expertise;

    return newState;
}

function setIndustries( newState, industries ) {
    newState.industries = industries;

    return newState;
}

function setRemunerationTypes( newState, remuneration_types ) {
    newState.remuneration_types = remuneration_types;

    return newState;
}

function setSectors( newState, sectors ) {
    newState.sectors = sectors;

    return newState;
}



// WEBPACK FOOTER //
// src/client/reducers/common/search.js